export class ArticleLocalization {
    saveButtonText: string = 'Save as Draft';
    updateButtonText: string = 'Update';
    publishButtonText: string = 'Submit for Review';
    retractButtonText: string = 'Retract';
    disclaimer1Text: string = 'I have reviewed and approved this content.'
        + ' I acknowledge that submitted content is subject to editorial review by Agility PR Solution\'s Newswire partner,'
        + ' Accesswire, and that the editorial review process may affect the timing and format of this release.';
    disclaimer2Text: string = 'The content contained in this submission is subject to public release.'
        + ' By continuing with this submission any further edits must be coordinated with the Accesswire editorial team directly.'
        + '<div class="agpr-article-publishDisclaimer-metadata">'
        + '<span class="agpr-article-publishDisclaimer-label agpr-article-publishDisclaimer-label--first">Phone</span>: 888.952.4446 x1'
        + '<span class="agpr-article-publishDisclaimer-label">Email</span>: '
        + '<a href="mailto:cs@accesswire.com" class="agpr-article-publishDisclaimer-email">cs@accesswire.com</a>'
        + '</div>';
    invalidVideoFormatMessage: string = 'Not a supported video format.';
    contactsEmailError = 'Invalid email format';
}
